import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import vuetify from "./plugins/vuetify";
import StoreMixin from "./mixins/store.mixin";
import LogRocket from "logrocket";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import { Auth0Plugin } from "./auth/authWrapper";
import { domain, clientId } from "./auth/auth0-variables.json";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import { VueLd } from "vue-ld";

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: (appState) => {
    router.push(
      `${appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname}`


    );
  },
});
Vue.mixin(StoreMixin);
Vue.use(VueLd, {
  clientSideId: process.env.LAUNCHDARKLY,
  user: {
    anonymous: true,
  },
  readyBeforeIdentify: false,
});
Vue.use(VuejsDialog);
Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_RAVEN,
  integrations: [new Integrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  // tracesSampleRate: 1.0,
});
if (process.env.NODE_ENV !== "development") {
  LogRocket.init(process.env.VUE_APP_LOGROCKET);
  LogRocket.getSessionURL((sessionURL) => {
    Sentry.configureScope((scope) => {
      scope.setExtra("sessionURL", sessionURL);
    });
  });
}
const app = new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

if (window.Cypress) {
  // only available during E2E tests
  window.app = app;
}
